import { AnyAction } from 'redux';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface GuiState {}

const initialState: GuiState = {};

export function guiReducer(state = initialState, action: AnyAction) {
  switch (action.type) {
    default:
      return state;
  }
}
